var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsletter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Newsletter",
    clipPath: "url(#clip0_25_348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.226 12.484C37.2484 11.2381 34.7519 11.2381 32.7743 12.484L4.14933 30.5187C3.88706 30.684 3.64519 30.8755 3.42188 31.0853L5.88703 36.5345L36 59.4345L65.9744 36.6552L68.5782 31.0853C68.3549 30.8755 68.113 30.684 67.8508 30.5187L39.226 12.484Z",
    fill: "#FBA615"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.34452 70.5438L7.36077 69.7253H62.1774L65.5497 68.4597V33.4181L36 56.1791L3.42003 31.084C2.5272 31.9211 1.96442 33.0824 1.91619 34.3382C1.91352 34.4088 1.91211 34.4805 1.91211 34.5532V67.0163C1.91211 68.3943 2.4597 69.6415 3.34452 70.5438Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M70.083 34.3383C70.0348 33.0824 69.472 31.9211 68.5792 31.084L64.1971 34.4593C64.1977 34.4906 64.199 34.5214 64.199 34.5532V67.0163C64.199 67.0661 64.1967 68.381 64.1953 68.4305L67.0089 70.2558L68.6527 70.5422C69.5378 69.64 70.0872 68.3945 70.0872 67.0163V34.5533C70.0871 34.4805 70.0857 34.4088 70.083 34.3383Z",
    fill: "#FCB143"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M65.5797 0H64.8464C62.4309 0 60.4727 1.9582 60.4727 4.37372V18.8902H66.6994C68.3351 18.8902 69.6612 17.5641 69.6612 15.9283V4.0815C69.6612 1.82742 67.8338 0 65.5797 0Z",
    fill: "#DAE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M56.638 4.0815C56.638 1.82742 58.4654 0 60.7196 0H14.1047C11.8475 0 10.0176 1.82981 10.0176 4.08712V36.1631L36.0007 56.1769L56.638 40.2806V4.0815Z",
    fill: "#F9F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M59.6889 0C57.4347 0 55.6074 1.82742 55.6074 4.0815V41.075L61.4993 36.5368V16.2145V4.0815C61.4992 1.82742 63.3266 0 65.5808 0H59.6889Z",
    fill: "#E7ECF1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M53.2456 9.17224H24.9323C24.3321 9.17224 23.8457 8.68582 23.8457 8.08563C23.8457 7.48545 24.3321 6.99902 24.9323 6.99902H53.2456C53.8458 6.99902 54.3322 7.48545 54.3322 8.08563C54.3322 8.68582 53.8458 9.17224 53.2456 9.17224Z",
    fill: "#A8D0D5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M53.246 15.9684H18.7546C18.1544 15.9684 17.668 15.482 17.668 14.8818C17.668 14.2816 18.1544 13.7952 18.7546 13.7952H53.2461C53.8463 13.7952 54.3327 14.2816 54.3327 14.8818C54.3326 15.482 53.8461 15.9684 53.246 15.9684Z",
    fill: "#A8D0D5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M53.246 22.7648H18.7546C18.1544 22.7648 17.668 22.2784 17.668 21.6782C17.668 21.078 18.1544 20.5916 18.7546 20.5916H53.2461C53.8463 20.5916 54.3327 21.078 54.3327 21.6782C54.3326 22.2784 53.8461 22.7648 53.246 22.7648Z",
    fill: "#A8D0D5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M53.2464 29.5609H36.0007C35.4005 29.5609 34.9141 29.0745 34.9141 28.4743C34.9141 27.8741 35.4005 27.3877 36.0007 27.3877H53.2464C53.8465 27.3877 54.333 27.8741 54.333 28.4743C54.333 29.0745 53.8465 29.5609 53.2464 29.5609Z",
    fill: "#A8D0D5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M53.2464 36.3573H36.0007C35.4005 36.3573 34.9141 35.8709 34.9141 35.2707C34.9141 34.6705 35.4005 34.1841 36.0007 34.1841H53.2464C53.8465 34.1841 54.333 34.6705 54.333 35.2707C54.333 35.8709 53.8465 36.3573 53.2464 36.3573Z",
    fill: "#A8D0D5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M30.1122 35.2709H19.7519C19.2007 35.2709 18.7539 34.824 18.7539 34.2729V29.4726C18.7539 28.9214 19.2008 28.4746 19.7519 28.4746H30.1122C30.6634 28.4746 31.1102 28.9215 31.1102 29.4726V34.2729C31.1102 34.824 30.6633 35.2709 30.1122 35.2709Z",
    fill: "#FBE77B"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M3.34375 70.5437C4.22645 71.4436 5.44483 72.0001 6.79033 72.0001H65.2082C66.5538 72.0001 67.7721 71.4436 68.6548 70.5437L38.5412 47.7268C37.0316 46.5829 34.9668 46.5829 33.4572 47.7268L3.34375 70.5437Z",
    fill: "#FDD8A3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/Newsletter.a74a8a1c53b0d81d9fb92a45754bf9ec.svg";
export { ForwardRef as ReactComponent };